import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const { Types: ExperienceTypes, Creators: ExperienceActions } = createActions(
  {
    setCurrentExperienceBySlug: ['slug'],
    setCurrentExperienceId: ['id'],
  },
  { prefix: 'EXPERIENCE_' }
);

export const INITIAL_STATE = Immutable({
  currentExperienceId: null,
});

const handleExperienceIdSet = (state, { id }) => state.set('currentExperienceId', id);

export const reducer = createReducer(INITIAL_STATE, {
  [ExperienceTypes.SET_CURRENT_EXPERIENCE_ID]: handleExperienceIdSet,
});
